import React, { useState, useEffect } from "react";
import instance from "../instance";
import "./Customer.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faStop,
  faRedo,
  faDesktop,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const ServerStatus = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openServers, setOpenServers] = useState({});
  const navigate = useNavigate();

  const fetchServerStatus = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await instance.get("contabo/status");
      setStatus(response.data);
      // toast.success("Server status loaded successfully!");
    } catch (error) {
      console.error("Error fetching server status:", error);
      setError("Error fetching server status.");
      // toast.error("Error fetching server status.");
    } finally {
      setLoading(false);
    }
  };

  const controlServer = async (instanceId, action, serverIp) => {
    confirmAlert({
      title: "Confirmation",
      message: `Are you sure you want to ${action} the server IP:${serverIp}?`,
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            setLoading(true);
            setError(null);
            try {
              const response = await instance.post(
                `contabo/${action}/${instanceId}`
              );
              console.log(`${action} server successful`, response.data);
              fetchServerStatus();
              toast.success(`Server ${action}ed successfully!`);
            } catch (error) {
              console.error(`Failed to ${action} server:`, error);
              setError(`Failed to ${action} server.`);
              toast.error(`Failed to ${action} server.`);
            } finally {
              setLoading(false);
            }
          },
        },
        { label: "No" },
      ],
    });
  };

  const formatNetmask = (ipConfig) => `/${ipConfig.netmaskCidr}`;

  const toggleServerDetails = (index) => {
    setOpenServers((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // تحميل البيانات عند تحميل الصفحة وتحديثها تلقائيًا كل 30 ثانية
  useEffect(() => {
    fetchServerStatus(); // تحميل البيانات عند فتح الصفحة
    const intervalId = setInterval(fetchServerStatus, 30000); // تحديث البيانات كل 30 ثانية

    return () => clearInterval(intervalId); // تنظيف المؤقت عند إلغاء تثبيت المكون
  }, []);

  return (
    <div>
      <header>
        <h1>Server Control</h1>
      </header>
      <main>
        <button onClick={() => navigate("/")} className="button">
          ← Main
        </button>
        <section id="app-section">
          <h2>Server Services</h2>
          {error && <p className="error-message">{error}</p>}
          {status &&
            status.data.map((server, index) => (
              <div key={index} className="server-container">
                <header>
                  <span className="info" id="info-displayName">
                    {server.displayName}
                  </span>
                </header>
                <div className="server-controls">
                  <FontAwesomeIcon
                    icon={faPlay}
                    onClick={() =>
                      controlServer(
                        server.instanceId,
                        "start",
                        server.ipConfig.v4.ip
                      )
                    }
                    className="icon"
                    title="Start"
                    disabled={loading}
                  />
                  <FontAwesomeIcon
                    icon={faStop}
                    style={{ color: "#fb0303" }}
                    onClick={() =>
                      controlServer(
                        server.instanceId,
                        "stop",
                        server.ipConfig.v4.ip
                      )
                    }
                    className="icon"
                    title="Stop"
                    disabled={loading}
                  />
                  <FontAwesomeIcon
                    icon={faRedo}
                    style={{ color: "#747674" }}
                    onClick={() =>
                      controlServer(
                        server.instanceId,
                        "restart",
                        server.ipConfig.v4.ip
                      )
                    }
                    className="icon"
                    title="Restart"
                    disabled={loading}
                  />
                  <FontAwesomeIcon
                    icon={faDesktop}
                    style={{
                      color:
                        server.status === "running" ? " #03b3f8" : "#cb0909",
                      cursor: "default",
                    }}
                    className="icon"
                    title={server.status === "running" ? "Running" : "Stopped"}
                  />
                  <FontAwesomeIcon
                    icon={openServers[index] ? faChevronUp : faChevronDown}
                    onClick={() => toggleServerDetails(index)}
                    className="icon"
                    title="Server Details"
                  />
                </div>
                {openServers[index] && (
                  <ul>
                    <li>
                      Instance ID:{" "}
                      <span className="info">{server.instanceId}</span>
                    </li>
                    <li>
                      Customer ID:{" "}
                      <span className="info">{server.customerId}</span>
                    </li>
                    <li>
                      Name: <span className="info">{server.name}</span>
                    </li>
                    <li>
                      Status: <span className="info">{server.status}</span>
                    </li>
                    <li>
                      OS Type: <span className="info">{server.osType}</span>
                    </li>
                    <li>
                      CPU: <span className="info">{server.cpuCores} Cores</span>
                    </li>
                    <li>
                      Memory: <span className="info">{server.ramMb} MB</span>
                    </li>
                    <li>
                      Storage: <span className="info">{server.diskMb} MB</span>
                    </li>
                    <li>
                      Product Type:{" "}
                      <span className="info">
                        {server.productType} ({server.productName})
                      </span>
                    </li>
                    <li>
                      Data Center:{" "}
                      <span className="info">
                        {server.dataCenter} - {server.regionName}
                      </span>
                    </li>
                    <li>
                      Region:{" "}
                      <span className="info">
                        {server.region} ({server.regionName})
                      </span>
                    </li>
                    <li>
                      MAC Address:{" "}
                      <span className="info">{server.macAddress}</span>
                    </li>
                    <li>
                      IPv4:{" "}
                      <span className="info">
                        {server.ipConfig.v4.ip}
                        {formatNetmask(server.ipConfig.v4)}
                      </span>
                    </li>
                    <li>
                      IPv4 Gateway:{" "}
                      <span className="info">{server.ipConfig.v4.gateway}</span>
                    </li>
                    <li>
                      IPv6:{" "}
                      <span className="info">
                        {server.ipConfig.v6.ip}
                        {formatNetmask(server.ipConfig.v6)}
                      </span>
                    </li>
                    <li>
                      IPv6 Gateway:{" "}
                      <span className="info">{server.ipConfig.v6.gateway}</span>
                    </li>
                    <li>
                      vHost Info:{" "}
                      <span className="info">
                        ID: {server.vHostId} | Number: {server.vHostNumber} |
                        Name: {server.vHostName}
                      </span>
                    </li>
                    <li>
                      Add-ons:{" "}
                      <span className="info">
                        {server.addOns
                          .map(
                            (addon) =>
                              `ID: ${addon.id} (Qty: ${addon.quantity})`
                          )
                          .join(", ")}
                      </span>
                    </li>
                    <li>
                      Default User:{" "}
                      <span className="info">{server.defaultUser}</span>
                    </li>
                    <li>
                      Created Date:{" "}
                      <span className="info">
                        {new Date(server.createdDate).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        })}
                      </span>
                    </li>
                    {server.cancelDate && (
                      <li>
                        Cancel Date:{" "}
                        <span className="info">
                          {new Date(server.cancelDate).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          })}
                        </span>
                      </li>
                    )}
                  </ul>
                )}
                {index < status.data.length - 1 && (
                  <hr className="server-separator" />
                )}
              </div>
            ))}
        </section>
      </main>
    </div>
  );
};

export default ServerStatus;
